export const getAllProviders = state =>
    state.primaryShippingProviders.concat(state.secondaryShippingProviders);

export const getAllProducts = state =>
    getAllProviders(state).flatMap(provider => provider.products);

export const getPrimaryOrSecondaryProducts = (state, onlyPrimary) =>
    (onlyPrimary
        ? state.primaryShippingProviders
        : state.secondaryShippingProviders
    ).flatMap(provider => provider.products);

export const getProduct = (state, onlyPrimary, productType) =>
    getPrimaryOrSecondaryProducts(state, onlyPrimary).find(
        product => product.type === productType
    );
